import { PopoverActions } from '@mui/material/Popover'
import { useRef, useCallback } from 'react'

export function usePopoverActions() {
  // this ref will be passed to the Popover
  // we use it to reposition the component when the content size changes
  const popoverActionsRef = useRef<PopoverActions>(null)

  const updatePosition = useCallback(
    () => void popoverActionsRef.current?.updatePosition(),
    [],
  )

  return {
    popoverActionsRef,
    updatePosition,
  }
}
